/* MK Domus - botao de alternar a cor do site (escuro / claro) */
(function () {
  var KEY = 'mk-theme';
  var root = document.documentElement;

  function atual() {
    return root.getAttribute('data-mk') === 'light' ? 'light' : 'dark';
  }

  function aplicar(modo) {
    if (modo === 'light') {
      root.setAttribute('data-mk', 'light');
    } else {
      root.removeAttribute('data-mk');
    }
    try { localStorage.setItem(KEY, modo); } catch (e) {}
    var b = document.getElementById('mkTheme');
    if (b) {
      b.setAttribute('aria-pressed', modo === 'light' ? 'true' : 'false');
      b.title = modo === 'light' ? 'Mudar para o fundo preto' : 'Mudar para o fundo branco';
    }
  }

  var SOL = '<svg class="mkt-sun" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4.2"/><path d="M12 2.6v2.2M12 19.2v2.2M4.5 4.5l1.6 1.6M17.9 17.9l1.6 1.6M2.6 12h2.2M19.2 12h2.2M4.5 19.5l1.6-1.6M17.9 6.1l1.6-1.6"/></svg>';
  var LUA = '<svg class="mkt-moon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.2 14.8A8.6 8.6 0 0 1 9.2 3.8a8.6 8.6 0 1 0 11 11z"/></svg>';

  function montar() {
    var acts = document.querySelector('.mkh__acts');
    if (!acts || document.getElementById('mkTheme')) return;

    var b = document.createElement('button');
    b.type = 'button';
    b.id = 'mkTheme';
    b.className = 'mkh__ico mkh__theme';
    b.setAttribute('aria-label', 'Alternar a cor do site');
    b.setAttribute('aria-pressed', atual() === 'light' ? 'true' : 'false');
    b.title = atual() === 'light' ? 'Mudar para o fundo preto' : 'Mudar para o fundo branco';
    b.innerHTML = SOL + LUA;
    b.addEventListener('click', function () {
      aplicar(atual() === 'light' ? 'dark' : 'light');
    });

    acts.insertBefore(b, acts.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }

  document.addEventListener('shopify:section:load', montar);
})();
